import styled from 'styled-components';

export const PageDisplayOuter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

export const PageDisplayContainer = styled.div`
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 20px;
  max-width: 700px;
  width: 100%;
  background-color: #f9f9f9;
`;

export const PageDisplayRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

export const PageDisplayTitle = styled.h4`
  min-width: 140px;
  margin: 0;
  color: #666;
`;

export const PageDisplayText = styled.p`
  margin-left: 10px;
  margin-bottom: 0;
  color: #333;
`;